export enum BloodTypeEnum {
  "A+" = "A_POSITIVO",
  "A-" = "A_NEGATIVO",
  "B+" = "B_POSITIVO",
  "B-" = "B_NEGATIVO",
  "AB+" = "AB_POSITIVO",
  "AB-" = "AB_NEGATIVO",
  "O+" = "O_POSITIVO",
  "O-" = "O_NEGATIVO",
}
